import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { postArticulo } from "../../redux/articulos/articulosAction";
import "../../index.css"

export default function ArticuloNuevo(){
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [form, setForm] = useState({
        codArticulo: "",
        nombre:"",
        ciclo:"",
        isbn:"",
        precio:""
    });
    
    const handleChange = (e) => {
        const {value} = e.target
        setForm({
            ...form,
            [e.target.name]: value
        })
    }

    const handleSubmit = () => {
        // if (codArticulo === ""
        //     || nombre === ""
        //     || ciclo === ""
        //     || isbn === ""
        //     || precio === ""){
                
        //     }
        dispatch(postArticulo(form))

    }

    return (
        <>
            <div className="bg-custom container-custom">
                <div className="text-orange-500">
                <div>
                    <h1>Nuevo Articulo</h1>                    
                </div>
                <div className="mt-8">
                    <div className="flex mb-4">
                        <label className="w-[150px] font-semibold">Codigo de Articulo</label>
                        <input
                            className="w-[300px] text-center bg-slate-700 no-spinner"
                            type="number"
                            name="codArticulo"
                            value={form.codArticulo}
                            onChange={handleChange}
                        />
                    </div>  
                    <div className="flex mb-4">
                        <label className="w-[150px] font-semibold">Nombre</label>
                        <input
                            className="w-[300px] text-center bg-slate-700"
                            type="text"
                            name="nombre"
                            value={form.nombre}
                            onChange={handleChange}
                        />
                    </div>  
                    <div className="flex mb-4">
                        <label className="w-[150px] font-semibold">Ciclo</label>
                        <input
                            className="w-[300px] text-center bg-slate-700"
                            type="text"
                            name="ciclo"
                            value={form.ciclo}
                            onChange={handleChange}
                        />
                    </div>  
                    <div className="flex mb-4">
                        <label className="w-[150px] font-semibold">ISBN</label>
                        <input
                            className="w-[300px] text-center bg-slate-700"
                            type="text"
                            name="isbn"
                            value={form.isbn}
                            onChange={handleChange}
                        />
                    </div>  
                    <div className="flex mb-4">
                        <label className="w-[150px] font-semibold">Precio</label>
                        <input
                            className="w-[300px] text-center bg-slate-700 no-spinner"
                            type="number"
                            name="precio"
                            value={form.precio}
                            onChange={handleChange}
                        />
                    </div>  
                </div>
                <div>
                    <button className="mt-10 rounded text-black font-bold w-[100px] h-[50px] bg-sky-400 hover:bg-sky-100 hover:text-gray-400"
                        onClick={handleSubmit}>
                        Crear Articulo
                    </button>
                </div>
                </div>
            </div>
        </>
    )
}